import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, ProgressBar } from '../../components/ui';
import { motion } from 'framer-motion';

const LINES = [
  { text: 'Our mission is simple.', delay: 0.5 },
  { text: 'To help you become...', delay: 1.5 },
  { text: 'the most attractive version of yourself.', delay: 2.5, highlight: 'most attractive' },
];

export function MissionScreen() {
  const navigate = useNavigate();
  const { nextStep } = useStore();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 3500);
    return () => clearTimeout(timer);
  }, []);

  const handleContinue = () => {
    nextStep();
    navigate('/onboarding/improve-more');
  };

  const renderLine = (line: typeof LINES[0], index: number) => {
    const { text, delay, highlight } = line;

    if (highlight) {
      const parts = text.split(highlight);
      return (
        <motion.p
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay, duration: 0.8 }}
          className="text-4xl md:text-5xl font-extrabold"
        >
          {parts[0]}
          <span className="text-accent">{highlight}</span>
          {parts[1]}
        </motion.p>
      );
    }

    return (
      <motion.p
        key={index}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay, duration: 0.8 }}
        className="text-3xl md:text-4xl font-semibold"
      >
        {text}
      </motion.p>
    );
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={6} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col justify-center items-center text-center space-y-4">
        {LINES.map((line, index) => renderLine(line, index))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: showButton ? 1 : 0 }}
        transition={{ duration: 0.5 }}
      >
        <Button onClick={handleContinue} disabled={!showButton}>
          Continue
        </Button>
      </motion.div>
    </div>
  );
}
